.standard-meetings-panel {

  .entityName,
  .state,
  .propertyName {
    white-space: nowrap;
    padding-right: 1rem;
    min-width: 5rem;
  }

}
